import { FC } from 'react';
import { Col, Image, Row, Typography } from 'antd';
import logo from 'assets/img/logo_report_dark.png';
import dayjs from 'dayjs';
import { REPORT_DATE_FORMAT } from 'constants/dates';
import { useTranslation } from 'react-i18next';

interface IProps {
  lng: string;
  date?: string;
  doctor_name: string;
}

const PreviewHeader: FC<IProps> = ({ lng, date, doctor_name }) => {
  const { t } = useTranslation();

  return (
    <Row justify="space-between">
      <Col>
        {doctor_name ? (
          <Typography.Text style={{ fontWeight: 'bold', fontSize: 12 }}>
            {doctor_name}
          </Typography.Text>
        ) : (
          <Image preview={false} src={logo} />
        )}
      </Col>
      {!!date && (
        <Col>
          <Typography.Text style={{ fontWeight: 500, color: '#0B1A30' }}>
            {t('reports.date', { lng })}{' '}
            {dayjs(date).format(REPORT_DATE_FORMAT)}
          </Typography.Text>
        </Col>
      )}
    </Row>
  );
};

export default PreviewHeader;
